export function getRestPhone(phone: string) {
	return phone
		.replace('+7', '')
		.replace(/[.*+?^${}()|[\]\\]/g, '')
		.replace(/\s/g, '')
		.replace(/-/g, '');
}
